import Header from "../components/Header";
import ManageReserveHeader from "../components/ManageReserveHeader";
import ReservationModi from "../components/ReservationModi";
import scroll from "../css/scroll.module.css"

function ManagerRsvModi() {
    return (
        <div className={scroll.scroll}>
            <Header />
            <ManageReserveHeader page={"reservation"} />


            <section className={scroll.scroll_section}>
                <ReservationModi />
            </section>
        </div>
    )
}

export default ManagerRsvModi;